import { createFileRoute } from '@tanstack/react-router';

import { IntegrationsScreen } from '@/screens/settings/IntegrationsScreen';

export const Route = createFileRoute('/_app/settings/integrations')({
  component: IntegrationsScreen,
});
